module.exports = __webpack_public_path__ + "img/MAC323_Z.d7d41b8f.png";